import styled from "styled-components";

interface IisDesktop {
	isDesktop: boolean;
	shadowOn?: boolean;
	isFixed?: boolean;
}

interface IPositionLayout extends IisDesktop {
	center?: boolean;
	left?: boolean;
	right?: boolean;
}

export const ContainerButtons = styled.div<IisDesktop>`
  width: 100%;
  position: ${(props) => (props.isDesktop ? "relative" : "fixed")};
  bottom: ${(props) => (props.isDesktop ? "auto" : "0px")};
  display: flex;
  flex-direction: ${(props) => (props.isDesktop ? "row" : "column")};
  justify-content: center;
  align-items: center;
  padding-top: 21px;
  padding-left: 21px;
  padding-bottom: 5px;
  padding-right: 21px;
  box-shadow: ${(props) =>
		!props.isDesktop && props.shadowOn ? "0px 0px 10px 1px #DDDDDD" : "none"};
  button {
    margin: 5px;
  }
`;

export const Layout = styled.div<IPositionLayout>`
  margin-bottom: ${(props) => (props.isDesktop ? "auto" : "166px")};
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 21px;
  padding-left: 21px;
  padding-bottom: 21px;
  padding-right: 21px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 680px;
`;
